export enum Color {
  C1 = '#333333',
  C2 = '#666666',
  C3 = '#999999',
  C4 = '#cccccc',
  C5 = '#f4f4f4',
  C6 = '#ffffff',
  C7 = '#0088cc',
  C8 = '#006699',
  C9 = '#59b36d',
  C10 = '#009220',
  C11 = '#ff0030',
  C12 = '#8b959b',
  C13 = '#aaacad',
  C14 = '#c8cbcc',
  C15 = '#808080',
  C16 = '#f0ad4e',
  C17 = '#fff7e6',
}

export enum FontSize {
  XXS = '0.625rem', // 10px
  XS = '0.75rem', // 12px
  S = '0.875rem', // 14px
  DEFAULT = '1rem', // 16px
  M = '1.125rem', // 18px
  L = '1.25rem', // 20px
  XL = '1.5rem', // 24px
  XXL = '2rem', // 32px
}

export enum Radius {
  DEFAULT = '3px',
  CIRCLE = '50%',
}

export const MAX_WIDTH = '320px';

export enum ROUTER_PATH {
  home = '/',
  login = '/login',
  oauth = '/oauth',
  oauthSignUp = '/oauth/signup',
  signUp = '/sign-up',
  samlLogin = '/saml-login',
  saml = '/saml',
  configurationProfile = '/configuration-profile',
  webclip = '/webclip',
  migration = '/migration',
  apps = '/apps',
  notificationSetting = '/notification-setting',
  emailActivations = '/email_activations/:activationCode',
  invitationDetail = '/invitations/:invitationToken',
  userApp = '/users/:userName/apps/:packageName/binaries/:revision',
  userAppSearch = '/users/:userName/apps/:packageName/binaries/:revision/search',
  groupApp = '/organizations/:groupName/apps/:packageName/binaries/:revision',
  groupAppSearch = '/organizations/:groupName/apps/:packageName/binaries/:revision/search',
  distribution = '/distributions/:distributionAccessKey',
  distributionComments = '/distributions/:distributionAccessKey/comments',
  sdkDeviceVerification = '/sdk_device_verification',
}

// deploygate.com 側のpath
export enum WEBFRONT_PATH {
  reset_password = '/reset_password',
}
